import { Component, Input, OnInit, input, viewChild } from '@angular/core';
import { ChartComponent, ApexAxisChartSeries, ApexChart, ApexXAxis, ApexYAxis, ApexTitleSubtitle, ApexPlotOptions, NgApexchartsModule } from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-volume-chart',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './volume-chart.component.html',
  styleUrl: './volume-chart.component.css'
})
export class VolumeChartComponent {
  readonly chart = viewChild.required<ChartComponent>('chart');
  readonly height = input<number>(250);
  public chartOptions: ChartOptions = this.setChartOptions();; // Partial<ChartOptions>;
  get XList():string[]{
    return this.itemList.map((item: any) => item.X);
  };
  _itemList: any[] = [];
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get itemList(): any[] {
    if(!this._itemList) return [];
    return this._itemList;
  }
  set itemList(value: any[]) {
    this._itemList = value;
  }
  constructor() {
    //this.chartOptions = this.setChartOptions();
  }
  setChartOptions(): ChartOptions {
    this.chartOptions = {
      series: [
        {
          name: 'volume',
          data: this.itemList.map((item: any) => item.qty)
        }
      ],
      chart: {
        height: 200,
        type: 'bar',
        zoom: {
          enabled: false
        }
      },
      xaxis: {
        labels: {show: false},
        categories: this.XList
      },
      yaxis: {
        title: {
          text: '成交量'
        }
      },
      title: {
        text: '',
        align: 'left',
      },
      plotOptions: {
        bar: {
          columnWidth: '50%'
        }
      }
    };
    return this.chartOptions;
  }

}
